import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { logoutUser } from "../../actions/authActions";
import SearchForm from "../Search/SearchForm";
import { toggleTheme } from "../../actions/themeActions";
import { Button } from "@material-ui/core";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },

  logo: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: theme.palette.primary.main,
    fontSize: 24,
    fontWeight: "bold",
    "&:hover": {
      color: theme.palette.primary.light,
    },
  },

  appBar: {
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
  },

  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1, 2),
  },
  
  menuButton: {
    color: theme.palette.primary.main,
  },
  
  menuLink: {
    textDecoration: "none",
    color: theme.palette.text.primary,
    "&:hover": {
      color: theme.palette.primary.light,
    },
  },

  accountIcon: {
    color: theme.palette.primary.main,
  },

  menuItemHover: {
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
});

const Header = ({ classes }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const store = useSelector((state) => state);
  const dispatch = useDispatch();

  const {
    auth: {user},
    darkMode: { darkMode }
  } = store;

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    dispatch(logoutUser());
  };

  const open = Boolean(anchorEl);

  const guestLinks = (
    <div style={{ display: 'flex', gap:'10px', alignItems: 'center' }}>
      <div className={classes.menuItemHover}>
        <Link to="/login" className={classes.menuLink}>
          Login
        </Link>
      </div>
  
      <div className={classes.menuItemHover}>
        <Link to="/register" className={classes.menuLink}>
          Register
        </Link>
      </div>
    </div>
  );

  const authLinks = isAuthenticated && (
    <div>
      <IconButton
        aria-owns={open ? "menu-appbar" : undefined}
        aria-haspopup="true"
        color="inherit"
        onClick={handleMenu}
        className={classes.menuButton}
      >
        <AccountCircle className={classes.accountIcon} />
      </IconButton>
    
      <Menu
        id="menu-appbar"
        open={open}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorEl={anchorEl}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} className={classes.menuItemHover}>
          <Link to={`/profile/${user._id}`} className={classes.menuLink}>
            Profile
          </Link>
        </MenuItem>
        
        <MenuItem className={classes.menuItemHover}>
          <Link to="/#" onClick={handleLogout} className={classes.menuLink}>
            Logout
          </Link>
        </MenuItem>
      </Menu>
    </div>
  );

  const bgColor = darkMode ? "black" : "white";
  const textColor = darkMode ? "white" : "black";

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ backgroundColor: bgColor, color: textColor }} className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Link to="/" className={classes.logo}>
            Vice Chat
          </Link>

          {isAuthenticated && <SearchForm />}
          <Button onClick={() => dispatch(toggleTheme())}>
            Toggle Theme
          </Button>

          {isAuthenticated ? authLinks : guestLinks}
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default withStyles(styles)(Header);
